// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","small":"_22zGKWmKy0aZd_9Ue1eYfN","body2":"_3SZbtBhXKsMgrIDYFmK8U","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","textGreen":"#009e66","customBlack":"#000000","productLink":"zx27abHmeg9COlevlNY2V","imageContainer":"_2tszRbNJ3dsZx3GqjdT-uX","textContainer":"_3Fu0czB46CrWw0IkLA89aw","brand":"_3xq19N4mVj1_Es7AozkbEx _22zGKWmKy0aZd_9Ue1eYfN","name":"_1WFqtttQCb9g1E6S0R3XI2 _3SZbtBhXKsMgrIDYFmK8U","price":"_1b6oHpZh5IHkNJR5_vnBgg _3tfkBLzh4oNF67_ojQV2Pn","undefinedPrice":"BleV_0nircCNKQ7aOaxS8 _22zGKWmKy0aZd_9Ue1eYfN"};


//////////////////
// WEBPACK FOOTER
// ./src/common/simple-product-card/SimpleProductCard.css
// module id = 1009
// module chunks = 1